import { createContext, useContext } from "react";
import { IResolvedLocalMap } from "@evennt-tech/api-v2-core";
import { defaultLocalMap } from "tools/show/localMap";

export const LocalMapContext = createContext<IResolvedLocalMap>(
  defaultLocalMap
);
export const useLocalMapContext = () => useContext(LocalMapContext);
